import { render, staticRenderFns } from "./batchAddSTPayment.vue?vue&type=template&id=3313199c&scoped=true&"
import script from "./batchAddSTPayment.vue?vue&type=script&lang=js&"
export * from "./batchAddSTPayment.vue?vue&type=script&lang=js&"
import style0 from "./batchAddSTPayment.vue?vue&type=style&index=0&id=3313199c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3313199c",
  null
  
)

export default component.exports